import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 25,
  },
  textInfo: {
    marginTop: 200,
    fontWeight: "700",
    fontSize: 17,
    lineHeight: 20,
    textAlign: "center",
  },
  contentBtn: {
    marginTop: 20,
    width: 340,
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  btn: {
    minWidth: 340,
    backgroundColor: "#970707",
    padding: 10,
    borderRadius: 4,
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },
});

export default styles;
